function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAlumniHorizontalLogo = function SvgAlumniHorizontalLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 1123.77 113.24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M329.7,111.66H319.08c-4.65,0-4.78-5.84-4.78-6.64-4.38,4.38-8.76,7.83-19.25,7.83-13.54,0-25.89-6.24-25.89-21.64,0-20.18,16.59-22.3,34.25-23,7.17-.26,10.49-2.79,10.49-6.77,0-4.65-5.31-9.16-13.54-9.16-6.77,0-13.41,2.65-17.52,8.36l-9.42-8.23c6.11-8.1,16.33-12.21,26.95-12.21,16.19,0,27.08,8.89,27.08,26v40.22c0,.93.53,2.79,2.26,2.79v2.39ZM314.44,80.19v-4c-2.92,4.12-12.08,3.45-16.46,3.72-13.14.66-14.34,7.57-14.34,11.28,0,3.32,2.26,10.09,11.42,10.09C312.18,101.3,314.44,91.74,314.44,80.19Z",
    style: {
      fill: "#bc1f2f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.51,111.66V17.41H350v94.25Z",
    style: {
      fill: "#bc1f2f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.27,41.43h14.47V84.31c0,13.28,7,16.06,12.21,16.06,9.82,0,21.9-4.78,21.9-30V41.43h14.47v70.22H407.85l-2.92-7a29,29,0,0,1-19.78,8.23c-18.45,0-25.88-10.22-25.88-27.61V41.43Z",
    style: {
      fill: "#bc1f2f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.24,111.66H516.77V69.58c0-9.16-1.86-16.46-11.82-16.46-8.63,0-15.13,4.91-15.13,29.6v28.94H475.35V71.17c0-7-1.33-18.05-11.82-18.05-14.07,0-16.86,14.47-16.86,26.42v32.12H432.2V41.44h14.34l2.39,6.11c5-5.44,10.49-7.3,15.4-7.3,6,0,15.8,1.46,20.84,10.62,6.9-8.76,15.93-10.62,19.78-10.62,25.89,0,26.28,19,26.28,30.93v40.48Z",
    style: {
      fill: "#bc1f2f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604,111.66H589.5V68.78c0-13.27-7-16.06-12.21-16.06-9.82,0-21.9,4.78-21.9,30v28.94H540.92V41.44h14.47l2.92,7a29,29,0,0,1,19.78-8.23c18.45,0,25.88,10.22,25.88,27.61Z",
    style: {
      fill: "#bc1f2f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.57,33.07H613V17.41h15.53Zm-15,8.36H628v70.22H613.57Z",
    style: {
      fill: "#bc1f2f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722,111.66H707.55V68.78c0-13.27-7-16.06-12.21-16.06-9.82,0-21.9,4.78-21.9,30v28.94H659V41.44h14.47l2.92,7a29,29,0,0,1,19.78-8.23c18.45,0,25.89,10.22,25.89,27.61v43.8Z",
    style: {
      fill: "#bc1f2f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.44,81.92H739.28c1.46,12.21,7.83,18,20.71,18,10,0,16.06-3.72,19.65-9.82l10.75,6.37c-5.44,9.56-16.72,16.33-30.4,16.33-21.5,0-34.78-13.94-34.78-36.24,0-20.84,13.41-36.37,34.78-36.37,20.31,0,32.66,14.34,33.45,35v6.64ZM780.3,69c-1.86-10.22-9.82-16.33-20.31-16.33-10.09,0-18,5.71-20.31,16.33Z",
    style: {
      fill: "#bc1f2f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M828.18,99.71a32,32,0,0,0,7.7-.8v12.35a93.24,93.24,0,0,1-14.73,1.59c-11.15,0-17.52-4.65-17.52-22.3V54.05H790.35V41.44h13.28v-24H818v24h17.92V54.05H818V89.36C818,97.32,821.81,99.71,828.18,99.71Z",
    style: {
      fill: "#bc1f2f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.25,111.66H860.44L839.07,41.44h15l13.27,48.05,13.28-48h16.46l13.28,48.05,13.27-48h15l-21.37,70.22H903.45L888.85,62Z",
    style: {
      fill: "#bc1f2f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M969.17,112.85c-19.51,0-35-16.33-35-36.24,0-18.45,14.07-36.37,35-36.37,20.71,0,34.78,17.92,34.78,36.37C1004,96.39,989.88,112.85,969.17,112.85Zm20.45-36.24c0-12-7-23.89-20.44-23.89-13,0-20.71,11.28-20.71,23.89,0,12.35,7.17,23.76,20.71,23.76C981.78,100.37,989.62,89,989.62,76.61Z",
    style: {
      fill: "#bc1f2f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.22,40.77V53.25a18.59,18.59,0,0,0-5.18-.53c-11.55,0-22.7,6.77-22.7,31.59v27.35H1010V41.44h14.34l3.19,8.1c6.24-6.37,13.67-9.29,19.51-9.29A29.59,29.59,0,0,1,1052.22,40.77Z",
    style: {
      fill: "#bc1f2f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1123.77,111.66h-17.66l-22.17-33.72-13,14.34v19.38h-14.47V17.41h14.47V72.63l27.74-31.19h18.59L1093.5,67.59Z",
    style: {
      fill: "#bc1f2f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.84,113.24a55.32,55.32,0,0,1-23.27-5.42A60,60,0,0,1,12.93,92.56c-.32-.38-8-9.66-10.8-20.72A56.22,56.22,0,0,1,.42,50c0-.33.63-10.92,8.65-24.2.27-.41,6-9.1,13.74-14.64A59.05,59.05,0,0,1,43.67,1.44c.45-.1,11.55-2.73,22.35-.62a62.31,62.31,0,0,1,20.8,7.8l1.06.63L79.76,27.48l-1.35-.85c-.11-.07-11.13-6.95-21.91-6.18h0a38.83,38.83,0,0,0-18.61,5.33,39.87,39.87,0,0,0-9.92,9,39,39,0,0,0-6,12,37.12,37.12,0,0,0-.71,16.93,38.43,38.43,0,0,0,7,15.2,37.28,37.28,0,0,0,12.26,10,36.31,36.31,0,0,0,21.1,3.41,32.73,32.73,0,0,0,15-5.75c.19-.12,5.86-3.4,11.69-13.4,0,0,.94-1.64,3.14-6.69l9.46-23.28L118.24,1.56h19.17l34.23,82.85L205.52,1.56h19L269.89,111H248L237.67,86.15l-45,0-10.27,24.73-21.59-.05L150.4,86.11h-46A107.34,107.34,0,0,1,94.68,98c-.13.16-5,5.9-15.38,10.4a53.73,53.73,0,0,1-22.23,4.78C57,113.22,56.56,113.24,55.84,113.24ZM57,2.79A61.35,61.35,0,0,0,44.29,4.14a57.24,57.24,0,0,0-19.83,9.27c-7.36,5.27-13,13.81-13,13.9-7.61,12.6-8.23,22.88-8.24,23A54.24,54.24,0,0,0,4.8,71.09C7.49,81.62,15,90.71,15.07,90.8a58.29,58.29,0,0,0,18.68,14.52A52.72,52.72,0,0,0,57,110.45a52,52,0,0,0,21.13-4.52c9.83-4.25,14.45-9.69,14.5-9.75A111.4,111.4,0,0,0,102.55,84l.41-.61h49.3l10.37,24.77,17.89,0,10.25-24.72,48.74-.06,10.36,24.78h15.86L222.67,4.3H207.38L171.66,91.68,135.55,4.32H120.09L103.47,44.19,94,67.49c-2.31,5.29-3.26,7-3.3,7C84.45,85.24,78.36,88.71,78.1,88.85A34.73,34.73,0,0,1,62,95a38.43,38.43,0,0,1-22.69-3.7A39.24,39.24,0,0,1,26.11,80.54a40.72,40.72,0,0,1-7.56-16.4,39.21,39.21,0,0,1,.8-18.28A40.84,40.84,0,0,1,25.8,33a42.32,42.32,0,0,1,10.69-9.63,41,41,0,0,1,19.95-5.7c9.32-.55,18.62,3.91,22.06,5.8l5.83-13.09A60.51,60.51,0,0,0,65.55,3.56,44.21,44.21,0,0,0,57,2.79ZM234,69.1l-37.42,0,18.19-46Zm-33.34-2.81,29.18,0-15-35.93ZM146.57,69.1l-37.43,0,18.2-46Zm-33.34-2.81,29.18,0-15-35.93Z",
    style: {
      fill: "#bc1f2f"
    }
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAlumniHorizontalLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/alumniHorizontalLogo.35b5599f.svg";
export { ForwardRef as ReactComponent };